module.exports = __webpack_public_path__ + "img/integracion-de-equipos.debfa784.png";